import ReadonlyCustomOption from "components/Freefields/Readonly/ReadonlyCustomOption";
import ReadonlyDate from "components/Freefields/Readonly/ReadonlyDate";
import ReadonlyDateTime from "components/Freefields/Readonly/ReadonlyDateTime";
import ReadonlyEmail from "components/Freefields/Readonly/ReadonlyEmail";
import ReadonlyMoney from "components/Freefields/Readonly/ReadonlyMoney";
import ReadonlyMultilineText from "components/Freefields/Readonly/ReadonlyMultilineText";
import ReadonlyNumber from "components/Freefields/Readonly/ReadonlyNumber";
import ReadonlyPercentage from "components/Freefields/Readonly/ReadonlyPercentage";
import ReadonlyWebsite from "components/Freefields/Readonly/ReadonlyWebsite";
import { YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import moment from "moment";
import React from "react";
import { findStateById } from "shared/utils/countrystateutils";
import { formatTime } from "utilities";

interface Props {
  type: server.dto.FormElementTypes
  value: string
  // The value as the server sent it, some types read extra context from it
  serverValue: string
  dropdownOptions: server.dto.DropdownOption[]
}

export const ReadonlyAdvancingValue = ({ type, value, serverValue, dropdownOptions }: Props) => {
  switch (type) {
    case "textSingleLine":
      return <>{value}</>;
    case "textMultiLine":
      return <ReadonlyMultilineText value={value} />;
    case "boolean":
    case "booleanNullable":
      return <YesNoText value={value === "Yes"} />;
    case "integer":
    case "integerNullable":
      return <ReadonlyNumber value={value} />;
    case "capacity":
      return <><ReadonlyNumber value={value} /> PAX</>;
    // The server already formats decimals in the user's culture
    case "decimal":
      return <>{value}</>;
    case "percentage":
      return <ReadonlyPercentage value={value} />;
    case "money":
      return <ReadonlyMoney value={value} serverValue={serverValue} />;
    case "dropdown":
      return <ReadonlyCustomOption value={value} dropdownOptions={dropdownOptions} />;
    case "date":
      return <ReadonlyDate value={value} />;
    case "dateTime":
      return <ReadonlyDateTime value={value} />;
    case "time":
      return <>{formatTime(moment.utc(value))}</>;
    case "url":
      return <ReadonlyWebsite value={value} />;
    case "email":
      return <ReadonlyEmail value={value} />;
    case "countryState": {
      const [countryId, stateId] = value.split("_");
      const country = serverReference.countries.find(c => c.key === countryId);
      const state = findStateById(parseInt(stateId), serverReference);
      return <>{state.name ? `${country.name} - ${state.name}` : country.name}</>;
    }
    default:
      throw new Error("Unknown advancing form element type: " + type);
  }
};
